import React from "react";
import "./Css/Loading.css";
function Loader() {
  return (
    <div className="loadingScreen">
      <div class="turbine">
        <div class="pilot">
          <div class="prop-container">
            <div class="prop"></div>
            <div class="prop"></div>
            <div class="prop"></div>
          </div>
        </div>
        <div class="pole"></div>
      </div>
    </div>
  );
}

export default Loader;
